
import debounce from '../js/debounce'
import EventRow from './event-row'
import qs from 'qs'

export default
    name: 'events-list'
    components: {EventRow}

    props: ['action']

    data: ->
        searchTerm: ''
        sport: null
        q: {}
        events: general.events || []
        loading: false

    created: ->
        @runDebouncedSearch = debounce((=> @search()), 350)

    computed:
        searchActive: ->
            @searchTerm.trim().length > 0 || @sport != null

        sportOptions: ->
            [
                {key: 'all', value: null, icon: 'fa-medal', label: @$t('events.index.search.all_sports')}
                {key: 'running', value: '0', icon: 'fa-running', label: @$t('events.index.search.sports.running')}
                {key: 'swimming', value: '1', icon: 'fa-swimmer', label: @$t('events.index.search.sports.swimming')}
                {key: 'cycling', value: '2', icon: 'fa-bicycle', label: @$t('events.index.search.sports.cycling')}
                {key: 'triathlon', value: '3', icon: 'fa-triangle', label: @$t('events.index.search.sports.triathlon')}
                {key: 'skiing', value: '4', icon: 'fa-skiing-nordic', label: @$t('events.index.search.sports.skiing')}
            ]

        selectedSport: ->
            @sportOptions.find((option) => option.value == @sport) || @sportOptions[0]

        todayKey: ->
            @localDateKey(new Date())

        tomorrowKey: ->
            tomorrow = new Date()
            tomorrow.setDate(tomorrow.getDate() + 1)
            @localDateKey(tomorrow)

        currentEvents: ->
            @events.filter (event) =>
                event.date_start >= @todayKey && event.date_start <= @tomorrowKey

        currentEventGroups: ->
            groups = @currentEvents.reduce ((result, event) ->
                result[event.date_start] ||= []
                result[event.date_start].push(event)
                result
            ), {}

            Object.keys(groups).sort().map (date) ->
                date: date
                events: groups[date]

        recentEvents: ->
            @events.filter (event) => event.date_start < @todayKey

    methods:
        localDateKey: (date) ->
            year = date.getFullYear()
            month = String(date.getMonth() + 1).padStart(2, '0')
            day = String(date.getDate()).padStart(2, '0')
            "#{year}-#{month}-#{day}"

        parseDate: (date) ->
            [year, month, day] = date.split('-').map(Number)
            new Date(year, month - 1, day)

        dateLocale: ->
            if @$i18n.locale == 'ru' then 'ru-RU' else 'en-US'

        formatCurrentHeading: (date) ->
            label = new Intl.DateTimeFormat(@dateLocale(), day: 'numeric', month: 'long').format(@parseDate(date))

            if date == @todayKey
                "#{@$t('events.index.today')}, #{label}"
            else if date == @tomorrowKey
                "#{@$t('events.index.tomorrow')}, #{label}"
            else
                label

        formatEventDate: (date) ->
            label = new Intl.DateTimeFormat(
                @dateLocale(),
                day: 'numeric', month: 'long', year: 'numeric'
            ).format(@parseDate(date))

            if @$i18n.locale == 'ru' then label.replace(/\s*г\.$/, '') else label

        syncSearch: ->
            term = @searchTerm.trim()
            if term.length
                @q.name_or_slug_cont = term
            else
                delete @q.name_or_slug_cont

            if @sport != null
                @q.sport_eq = @sport
            else
                delete @q.sport_eq

            @runDebouncedSearch()

        search: ->
            @loading = true
            params = {q: @q}
            axios_config = {
                params: params,
                paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'brackets', encode: false})
            }

            @axios.get(@action, axios_config).then((res) =>
                @events = res.data
            ).finally(=>
                @loading = false
            )

    watch:
        searchTerm: -> @syncSearch()
        sport: -> @syncSearch()
